import { Component, ComponentInterface, Element, h, Host } from "@stencil/core";

@Component({
    tag: "uic-breadcrumb",
    styleUrl: "breadcrumb.scss"
})
export class Breadcrumb implements ComponentInterface {
    private observer: ResizeObserver;
    @Element() host: HTMLUicBreadcrumbElement;

    connectedCallback() {
        this.observer = new ResizeObserver(() => {
            if (!this.host) {
                return;
            }

            // let all breadcrumb items have their full width...
            this.host.classList.add("override");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = Array.from<any>(this.host.children);
            const actualWidth = this.host.offsetWidth;
            const desiredWidth = this.host.scrollWidth;

            // ...and hide them again if they exceed the available width.
            if (desiredWidth <= actualWidth) {
                children.forEach((el) => (el.ellipsis = false));
            } else {
                children.forEach((el, index) => (el.ellipsis = !(index === 0 || index === children.length - 1)));
            }

            this.host.classList.remove("override");
        });
    }

    componentDidLoad() {
        this.observer.observe(this.host);
    }

    disconnectedCallback() {
        this.observer.disconnect();
    }

    render() {
        return (
            <Host class='uic-breadcrumb'>
                <slot></slot>
            </Host>
        );
    }
}
